export const aboutBrand = {
  title: '关于 qiaojzx.cn',
  subtitle: '让服务触手可及',
  description: 'qiaojzx.cn 创立于 2020 年，致力于为用户打造安全、便捷、高效的一站式综合服务平台。我们整合多项核心服务于一体，以技术创新为驱动，以用户体验为核心，持续为全球数百万用户提供优质的在线服务。',
  vision: '成为全球最受信赖的综合服务平台，让每个人都能轻松获取所需的在线服务。',
  mission: '以技术创新简化服务流程，以安全保障用户权益，以专业态度赢得用户信赖。',
};

export const aboutMilestones = [
  { year: '2020', title: '平台创立', description: 'qiaojzx.cn 正式上线，推出核心服务模块，首批用户突破 1 万人。' },
  { year: '2021', title: '快速发展', description: '注册用户突破 100 万，新增智能搜索和数据处理两大核心功能。' },
  { year: '2022', title: '规模扩张', description: '用户数突破 500 万，通过 ISO 27001 认证，服务覆盖 100+ 国家和地区。' },
  { year: '2023', title: '技术升级', description: '完成微服务架构升级，推出移动端版本，日均处理请求突破 1 亿次。' },
  { year: '2024', title: '生态完善', description: '上线即时通讯和支付结算模块，构建完整的服务生态系统。' },
  { year: '2025', title: '全球布局', description: '全球 CDN 节点突破 200 个，服务覆盖 180+ 国家和地区，用户数突破 1000 万。' },
  { year: '2026', title: '创新引领', description: '推出 AI 智能助手，发布微信小程序版本，持续引领行业创新方向。' },
];

export const aboutCertifications = [
  { title: 'ISO 27001 信息安全管理', description: '国际信息安全管理体系认证', icon: 'ri-shield-check-line' },
  { title: 'SOC 2 Type II', description: '服务组织控制体系认证', icon: 'ri-file-shield-2-line' },
  { title: 'GDPR 合规', description: '欧盟通用数据保护条例合规', icon: 'ri-lock-line' },
  { title: '等保三级', description: '国家信息安全等级保护三级认证', icon: 'ri-building-4-line' },
];

export const aboutContact = {
  address: '中国上海市浦东新区张江高科技园区博云路 2 号浦软大厦 15 层',
  phone: '400-888-9999',
  email: 'contact@qiaojzx.cn',
  workHours: '周一至周日 9:00 - 21:00',
};